<template>
  <div>
    <div class="table_card">
      <div class="table_card__head">
        <p class="table_card__head--title">Logs de acciones de Counter</p>
      </div>

      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 md4 style="padding: 8px;">
            <v-select
              v-model="counterFilterId"
              :items="counterSelectItems"
              item-text="text"
              item-value="value"
              label="Filtrar por Counter"
            ></v-select>
          </v-flex>

          <v-flex xs12 md4 style="padding: 8px;">
            <v-menu
              v-model="fromDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="fromDate"
                  label="Fecha desde"
                  append-icon="today"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="fromDate" @input="fromDateMenu = false"></v-date-picker>
            </v-menu>
          </v-flex>

          <v-flex xs12 md4 style="padding: 8px;">
            <v-menu
              v-model="toDateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="toDate"
                  label="Fecha hasta"
                  append-icon="today"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="toDate" @input="toDateMenu = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>

        <v-progress-linear v-if="loading" indeterminate height="3" class="ma-0"></v-progress-linear>
        <p v-if="loadError" class="red--text" style="padding: 8px 0;">{{ loadError }}</p>

        <v-data-table
          :headers="headers"
          :items="logs"
          class="elevation-1"
          :no-data-text="loading ? 'Cargando…' : 'No hay registros para los filtros seleccionados.'"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.counter_name }}</td>
            <td>{{ props.item.user_name }}</td>
            <td>{{ props.item.location_name }}</td>
            <td>{{ props.item.action }}</td>
            <td>{{ props.item.action_date }}</td>
            <td>{{ props.item.action_time }}</td>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
</template>

<script>

const COUNTER_ACTION_LOGS_PATH = 'app/counter_action_logs'

const ALL_COUNTERS = '__all__'

export default {
  data() {
    return {
      fromDateMenu: false,
      toDateMenu: false,
      fromDate: '',
      toDate: '',
      counterFilterId: ALL_COUNTERS,
      counterSelectItems: [{ text: 'Todos', value: ALL_COUNTERS }],
      loading: false,
      loadError: '',
      headers: [
        { text: 'Usuario', value: 'counter_name', sortable: false },
        { text: 'Cliente', value: 'user_name', sortable: false },
        { text: 'Sede', value: 'location_name', sortable: false },
        { text: 'Acción', value: 'action', sortable: false },
        { text: 'Fecha', value: 'action_date', sortable: false },
        { text: 'Hora', value: 'action_time', sortable: false }
      ],
      logs: []
    }
  },
  watch: {
    fromDate() {
      this.loadLogs()
    },
    toDate() {
      this.loadLogs()
    },
    counterFilterId() {
      this.loadLogs()
    }
  },
  mounted() {
    this.loadLogs()
  },
  methods: {
    extractRawList(body) {
      if (!body) return []
      if (Array.isArray(body)) return body
      if (Array.isArray(body.data)) return body.data
      if (Array.isArray(body.logs)) return body.logs
      return []
    },
    actionDisplayForRow(r) {
      if (r.action_label != null && String(r.action_label).trim() !== '') {
        return String(r.action_label)
      }
      const code = r.action != null ? String(r.action) : ''
      const legacy = {
        update_client_by_counter: 'Edición desde Counter (histórico)',
        counter_update_general: 'Cambio de información general',
        counter_photo_changed: 'Cambio de foto',
        counter_photo_uploaded: 'Subida de foto'
      }
      return legacy[code] != null ? legacy[code] : code
    },
    normalizeLogRow(row) {
      const r = row && row.attributes ? row.attributes : row || {}
      let actionDate = r.action_date != null ? String(r.action_date) : ''
      let actionTime = r.action_time != null ? String(r.action_time) : ''
      if (r.occurred_at) {
        const d = new Date(r.occurred_at)
        if (!isNaN(d.getTime())) {
          actionDate = d.toISOString().substr(0, 10)
          var hh = ('0' + d.getHours()).slice(-2)
          var mm = ('0' + d.getMinutes()).slice(-2)
          actionTime = hh + ':' + mm
        }
      }
      const id = row && row.id != null ? row.id : (r.id != null ? r.id : null)
      return {
        id,
        counter_id: r.counter_id != null ? r.counter_id : null,
        counter_name: r.counter_name != null ? String(r.counter_name) : '',
        user_name: r.user_name != null ? String(r.user_name) : '',
        location_name: r.location_name != null ? String(r.location_name) : '',
        action: this.actionDisplayForRow(r),
        action_date: actionDate,
        action_time: actionTime
      }
    },
    applyCounterFiltersFromMeta(meta) {
      const base = [{ text: 'Todos', value: ALL_COUNTERS }]
      if (meta && Array.isArray(meta.counter_filters) && meta.counter_filters.length > 0) {
        const rest = meta.counter_filters.map(function (c) {
          const id = c.id != null ? c.id : (c.attributes && c.attributes.id)
          const name = c.name != null ? c.name : (c.attributes && c.attributes.name)
          return {
            text: name != null ? String(name) : String(id),
            value: id != null ? String(id) : ALL_COUNTERS
          }
        })
        this.counterSelectItems = base.concat(rest)
        return
      }
      this.counterSelectItems = base
    },
    augmentCounterSelectFromLogs(logsNorm) {
      if (this.counterSelectItems.length > 1) return
      const byId = {}
      logsNorm.forEach(function (l) {
        if (l.counter_id != null && l.counter_name) {
          byId[String(l.counter_id)] = l.counter_name
        }
      })
      const keys = Object.keys(byId)
      if (keys.length === 0) return
      const base = [{ text: 'Todos', value: ALL_COUNTERS }]
      const rest = keys.map(function (id) {
        return { text: byId[id], value: id }
      })
      this.counterSelectItems = base.concat(rest)
    },
    loadLogs() {
      var self = this
      self.loading = true
      self.loadError = ''
      var params = {}
      if (self.fromDate) params.date_from = self.fromDate
      if (self.toDate) params.date_to = self.toDate
      if (self.counterFilterId && self.counterFilterId !== ALL_COUNTERS) {
        params.counter_id = self.counterFilterId
      }
      self.$http
        .get(COUNTER_ACTION_LOGS_PATH, {
          headers: {
            'X-Device-ID': self.getDeviceId(),
            Authorization: 'Bearer ' + self.getUserToken()
          },
          params: params
        })
        .then(
          function (response) {
            self.loading = false
            if (
              response.body &&
              response.body.meta &&
              response.body.meta.authentication_token
            ) {
              self.checkToken(response.body.meta.authentication_token)
            }
            var body = response.body
            var rawList = self.extractRawList(body)
            var meta = body && body.meta ? body.meta : null
            self.applyCounterFiltersFromMeta(meta)
            var logsNorm = rawList.map(function (row) {
              return self.normalizeLogRow(row)
            })
            self.logs = logsNorm
            self.augmentCounterSelectFromLogs(logsNorm)
          },
          function (response) {
            self.loading = false
            self.logs = []
            if (
              response.body &&
              response.body.meta &&
              response.body.meta.authentication_token
            ) {
              self.checkToken(response.body.meta.authentication_token)
            }
            var detail =
              response.body &&
              response.body.errors &&
              response.body.errors[0] &&
              response.body.errors[0].details
            self.loadError =
              typeof detail === 'string'
                ? detail
                : 'No se pudieron cargar los logs de Counter. Verifique que el endpoint esté disponible ('
                  .concat(String(response.status || ''))
                  .concat(').')
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/access/counter/CounterActionLogs.vue